import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { PAGING_HEADERS } from '@app/app.constants';
import {
  FollowUp,
  FollowUpsUser,
  ProvisionFollowUp,
} from '@app/modules/follow-ups/follow-ups.types';
import { ApiHeaders } from '@core/core.types';
import { HttpUtils } from '@core/utils/http-utils';
import { environment } from '@root/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FollowUpsService {
  private http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiUrl}/service-data/follow-ups`;

  getUsers() {
    return this.http.get<FollowUpsUser[]>(`${this.apiUrl}/users`);
  }

  getFollowUp(followUpId: string) {
    return this.http.get<FollowUp>(`${this.apiUrl}/${followUpId}`);
  }

  createFollowUp(followUp: ProvisionFollowUp) {
    return this.http.post<{ id: string }>(`${this.apiUrl}`, followUp);
  }

  deleteFollowUp(followUpId: string) {
    return this.http.delete(`${this.apiUrl}/${followUpId}`);
  }

  listFollowUps(filters: HttpParams, headers: ApiHeaders) {
    return this.http
      .get<FollowUp[]>(`${this.apiUrl}`, {
        observe: 'response',
        params: filters,
        headers: HttpUtils.buildHttpHeaders(headers),
      })
      .pipe(
        map((response) => ({
          items: response.body,
          continuationToken: response.headers.get(
            PAGING_HEADERS.continuationToken
          ),
          totalCount: parseInt(
            response.headers.get(PAGING_HEADERS.totalCount),
            10
          ),
        }))
      );
  }

  archiveFollowUps(followUpIds: string[]) {
    return this.http.post(`${this.apiUrl}/batch/archive`, { followUpIds });
  }

  assignFollowUps(followUpIds: string[], assignee: string) {
    return this.http.post(`${this.apiUrl}/batch/assign`, {
      followUpIds,
      assignee,
    });
  }

  resolveFollowUps(followUpIds: string[]) {
    return this.http.post(`${this.apiUrl}/batch/resolve`, { followUpIds });
  }

  setNotes(followUpId: string, notes) {
    return this.http.patch(`${this.apiUrl}/${followUpId}/notes`, {
      notes,
    });
  }
}
